import { render, staticRenderFns } from "./deanInputSwitch.vue?vue&type=template&id=6e68e40b&scoped=true"
import script from "./deanInputSwitch.vue?vue&type=script&lang=ts"
export * from "./deanInputSwitch.vue?vue&type=script&lang=ts"
import style0 from "./deanInputSwitch.vue?vue&type=style&index=0&id=6e68e40b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e68e40b",
  null
  
)

export default component.exports